import { captureError } from '@/sentry';

const DEV_MODE_KEY = 'morseHeroDevMode';

// Track D-E-V key sequence for toggling dev mode
let devKeySequence = '';

function handleDevKeyInput(event: KeyboardEvent): void {
  const key = event.key.toUpperCase();
  // Only process letter keys
  if (!/^[A-Z]$/.test(key)) {
    devKeySequence = '';
    return;
  }

  devKeySequence += key;

  // Keep only last 3 characters
  if (devKeySequence.length > 3) {
    devKeySequence = devKeySequence.slice(-3);
  }

  // Check for D-E-V sequence
  if (devKeySequence === 'DEV') {
    toggleDevMode();
    devKeySequence = '';
  }
}

export function isDevMode(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const stored = window.localStorage?.getItem(DEV_MODE_KEY);
    return stored === '1' || stored === 'true';
  } catch (error) {
    captureError(error, { scope: 'debug', action: 'isDevMode' });
    return false;
  }
}

export function toggleDevMode(): void {
  const newValue = !isDevMode();
  try {
    window.localStorage?.setItem(DEV_MODE_KEY, newValue ? '1' : '0');
    console.log('[dev]', newValue ? 'DEV MODE ENABLED' : 'DEV MODE DISABLED');
    // Notify listeners that dev mode changed
    window.dispatchEvent(new CustomEvent('devmodechange', { detail: { enabled: newValue } }));
  } catch (error) {
    captureError(error, { scope: 'debug', action: 'toggleDevMode' });
  }
}

// Initialize dev mode key listener
if (typeof window !== 'undefined') {
  window.addEventListener('keydown', handleDevKeyInput);
}

export function isDebugEnabled(): boolean {
  // Debug mode is now solely controlled by dev mode
  return isDevMode();
}

export function debugLog(...args: unknown[]): void {
  if (!isDebugEnabled()) return;
  console.log('[debug]', ...args);
}

export function debugWarn(...args: unknown[]): void {
  if (!isDebugEnabled()) return;
  console.warn('[debug]', ...args);
}

export function debugError(...args: unknown[]): void {
  if (!isDebugEnabled()) return;
  console.error('[debug]', ...args);
}
